import { Avatar, Tag, Text } from '@conexasaude/conexa-hero'
import { FunctionComponent } from 'react'
import { AvatarWithDependentsAccessProps } from './types'
import { useStyles } from './styles'
import DivisorLine from '../DivisorLine'
import { RenderIf } from '../RenderIf'
import { capitalizeFirstLetter } from '@/utils/string'

const AvatarWithDependentsAccess: FunctionComponent<
  AvatarWithDependentsAccessProps
> = ({ props }) => {
  const styles = useStyles()
  const onActionClick = () => {
    props?.onActionClick?.()
    props?.closeAction?.()
    props?.toggle?.()
  }

  return (
    <div css={styles.containerWrapper}>
      <div css={styles.container}>
        <div css={styles.avatarWrapper}>
          <Avatar size="medium" src={props?.photo} />
          <div css={styles.textWrapper}>
            <Text variant="label">{capitalizeFirstLetter(props?.label)}</Text>
            <RenderIf condition={props.showButton}>
              <Text
                variant="linkUnderline"
                renderAs="span"
                onClick={onActionClick}
              >
                {props?.nameButton}
              </Text>
            </RenderIf>
          </div>
        </div>
        <RenderIf condition={props.showTag}>
          <Tag variant={props?.tagVariant} size="small">
            {props?.tagLabel}
          </Tag>
        </RenderIf>
      </div>
      <DivisorLine css={styles.divisorLine} />
    </div>
  )
}

export { AvatarWithDependentsAccess }
